// extracted by mini-css-extract-plugin
export default {"container":"WhyCertify_container__AcDLy","topBar":"WhyCertify_topBar__vy9dQ","button":"WhyCertify_button__M6Y2w","content":"WhyCertify_content__EWzBW"};